export type IncidentStatus =
  | 'DRAFT'
  | 'NEW'
  | 'ACKNOWLEDGE'
  | 'IN_PROGRESS'
  | 'BLOCKED'
  | 'DONE'
  | 'CLOSED'

export type IncidentPriority = 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW'

export type IncidentSource = 'ai' | 'VOICE' | null

export interface Incident {
  id: number
  property_id: number
  conversation_id: number | null
  title: string
  description: string | null
  location: string | null
  priority: IncidentPriority
  status: IncidentStatus
  source: IncidentSource
  intent: string | null
  confidence: number | null
  assignee_user_id: number | null
  assignee_team_id: number | null
  created_by_user_id: number | null
  due_at: string | null
  acknowledged_at: string | null
  started_at: string | null
  completed_at: string | null
  created_at: string
  updated_at: string | null
}

export interface IncidentStatusUpdate {
  status?: IncidentStatus
  title?: string
  description?: string | null
  priority?: IncidentPriority
  assignee_user_id?: number | null
  assignee_team_id?: number | null
  due_at?: string | null
}

export interface IncidentFilters {
  priorities: IncidentPriority[]
  statuses: IncidentStatus[]
}

export const INCIDENT_STATUSES: IncidentStatus[] = [
  'DRAFT',
  'NEW',
  'ACKNOWLEDGE',
  'IN_PROGRESS',
  'BLOCKED',
  'DONE',
  'CLOSED',
]

export const INCIDENT_PRIORITIES: IncidentPriority[] = [
  'CRITICAL',
  'HIGH',
  'MEDIUM',
  'LOW',
]
